<h2>{{ contact.name }} - {{ contact.phoneNumber | phoneNumberFormatter }}</h2>
<mat-dialog-content class="mat-typography">
  <div fxLayout="row wrap" fxLayoutWrap class="gt-content" fxLayoutGap="16px">
    <div fxLayout="column" fxFlex fxLayoutGap="16px">
      <gt-card-wrapper
        *ngIf="hasTrigging && hasInboundFeatures"
        class="user-component"
        cardTitle="{{ 'status.title' | translate }}"
        matIcon="event"
        fxFlex="0 1 auto"
      >
        <gt-status [login]="contact.login" [orgname]="contact.oname" [canEdit]="canEdit" [hasPolling]="hasPolling"></gt-status>
      </gt-card-wrapper>
      <gt-card-wrapper class="user-component" cardTitle="{{ 'queue.my_queues' | translate }}" matIcon="headset_mic" fxFlex>
        <gt-queue [login]="contact.login" [oname]="contact.oname" [canEdit]="canEdit"></gt-queue>
      </gt-card-wrapper>
      <gt-card-wrapper *ngIf="hasTrigging" class="user-component" cardTitle="{{ 'more.title' | translate }}" matIcon="settings" fxFlex>
        <gt-user-settings
          [showStatus]="false"
          [showForwarding]="hasInboundFeatures"
          [showAdvancedSettings]="hasInboundFeatures"
          [login]="contact.login"
          [orgname]="contact.oname"
          [canEdit]="canEdit"
          [fullNumber]="contact.phoneNumber"
        ></gt-user-settings>
      </gt-card-wrapper>
    </div>
  </div>
</mat-dialog-content>
